import React from 'react';
import { withNamespaces } from 'react-i18next';
import T from 'prop-types';

import { load as loadStatus } from 'resources/liquidStatus';

import Navigation from './Navigation';
import Copyright from './Copyright';
import RiskDisclosure from './RiskDisclosure';

import logoBlue from './liquid-logo-blue.svg';
import logoWhite from './liquid-logo-white.svg';
import './styles.scss';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      liquidStatus: '',
    };
  }

  async componentDidMount() {
    const { indicator } = await loadStatus();
    const liquidStatus = this.getStatusStyle(indicator);
    this.setState({ liquidStatus });
  }

  getStatusStyle = (indicator) => {
    switch (indicator) {
      case 'none': return 'green';
      case 'minor': return 'orange';
      case 'major': return 'red';
      case 'critical': return 'red';
      default: return '';
    }
  }

  render() {
    const { logo, width, isWhite, black, bottomNote, isRiskDisclosureHidden } = this.props;
    const Logo = logo || (!black ? logoBlue : logoWhite);
    return (
      <footer className={`footer ${black ? 'footer--black' : ''}`}>
        <div className="footer__menu">
          <Navigation
            logo={Logo}
            width={width || 129}
            height={32}
            isWhite={isWhite}
            liquidStatus={this.state.liquidStatus}
          />
        </div>
        <div className="container">
          <Copyright note={bottomNote} />
        </div>
        {!isRiskDisclosureHidden && <RiskDisclosure />}
      </footer>
    );
  }
}

Footer.defaultProps = {
  isWhite: false,
  black: false,
  bottomNote: '',
};


Footer.propTypes = {
  isWhite: T.bool,
  black: T.bool,
  bottomNote: T.string,
  logo: T.oneOfType([T.shape({}), T.string]),
  width: T.number,
};

export default withNamespaces()(Footer);



// WEBPACK FOOTER //
// ../src/components/Footer/index.jsx